import { APPLIED_COUPON_STATE_KEY } from '@/data/constants/hdmDataKey';
import { FACET_LIMIT_STATE_KEY } from '@/data/constants/facet';
import { PRODUCT_INFO_STATE_KEY } from '@/data/constants/product';

// Facet expansion is transient UI state — never persist it to session/local storage.

export const SKIP_STORAGE_KEY = [
	PRODUCT_INFO_STATE_KEY,
	FACET_LIMIT_STATE_KEY,
	APPLIED_COUPON_STATE_KEY,
];
